import { Col, Row, Spin } from "antd";

import Loader from "@ui/feedback/loader";

import AuthAlert from "../auth-alert";
import AuthHeader from "../auth-header";

const AuthShell = ({
  alertType,
  children,
  footer = null,
  loading = false,
  message,
  spinClassName = "top-[45%] flex items-center justify-center",
  title
}) => {
  return (
    <div className="min-h-screen min-w-[100vw] m-0 bg-white overflow-y-scroll">
      <Spin indicator={<Loader />} spinning={loading} className={spinClassName}>
        <Row className="flex flex-col justify-center items-center [&>div]:w-full">
          <Col>
            <AuthHeader title={title} />
          </Col>

          <Col xs={22} md={20} lg={18} xl={11} xxl={11}>
            <AuthAlert type={alertType} msg={message} />
            {children}
            {footer}
          </Col>
        </Row>
      </Spin>
    </div>
  );
};

export default AuthShell;
